if (!customElements.get('brita-download-center')) {
  class BritaDownloadCenter extends HTMLElement {
    connectedCallback() {
      this.filterButtons = this.querySelectorAll('.brita-dc__filter-btn');
      this.groups = this.querySelectorAll('.brita-dc__group');
      this.items = this.querySelectorAll('.brita-dc__item');
      this.applicationFilter = this.querySelector('.brita-dc__application-filter');
      this.productFilter = this.querySelector('.brita-dc__product-filter');
      this.emptyState = this.querySelector('.brita-dc__empty');

      this.activeCategory = 'all';
      this.activeApplication = 'all';
      this.activeProduct = 'all';

      this.bindEvents();
    }

    bindEvents() {
      this.filterButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.activeCategory = btn.dataset.category;
          this.updateFilters();
          this.updateActiveButton(btn);
        });
      });

      if (this.applicationFilter) {
        this.applicationFilter.addEventListener('change', (e) => {
          this.activeApplication = e.target.value;
          this.updateFilters();
        });
      }

      if (this.productFilter) {
        this.productFilter.addEventListener('change', (e) => {
          this.activeProduct = e.target.value;
          this.updateFilters();
        });
      }
    }

    updateFilters() {
      let visibleCount = 0;

      this.groups.forEach((group) => {
        const categoryHandle = group.dataset.category;
        const categoryMatch =
          this.activeCategory === 'all' || categoryHandle === this.activeCategory;

        if (!categoryMatch) {
          group.classList.add('hidden');
          return;
        }

        const groupItems = group.querySelectorAll('.brita-dc__item');
        let groupVisible = 0;

        groupItems.forEach((item) => {
          const appValue = item.dataset.application || '';
          const prodValue = item.dataset.product || '';

          const applicationMatch =
            this.activeApplication === 'all' || appValue === this.activeApplication;
          const productMatch =
            this.activeProduct === 'all' || prodValue === this.activeProduct;

          const visible = applicationMatch && productMatch;
          item.classList.toggle('hidden', !visible);
          if (visible) groupVisible++;
        });

        group.classList.toggle('hidden', groupVisible === 0);
        visibleCount += groupVisible;
      });

      if (this.emptyState) {
        this.emptyState.classList.toggle('hidden', visibleCount > 0);
      }
    }

    updateActiveButton(activeBtn) {
      this.filterButtons.forEach((btn) => btn.classList.remove('active'));
      activeBtn.classList.add('active');
    }
  }

  customElements.define('brita-download-center', BritaDownloadCenter);
}
